import { initializeApp } from 'firebase/app';

const firebaseConfig = {
    apiKey: "AIzaSyCZQRkQDAcoS5_tvtP-2D-3bb6eSYBIT34",
    authDomain: "organizeflow-92efa.firebaseapp.com",
    projectId: "organizeflow-92efa",
    storageBucket: "organizeflow-92efa.firebasestorage.app",
    messagingSenderId: "65607159384",
    appId: "1:65607159384:web:6e11925901d6d12623842d",
    measurementId: "G-3HL4XRPQRM"
  };

const app = initializeApp(firebaseConfig);
export default app;
